<script>
  import {onMount, onDestroy} from "svelte";
  import RantsList from "./RantsList.svelte";
  import FullStack from "./FullStack.svelte";
  import JWTLambda from "./JWTLambda.svelte";

  let displayStatus

  onMount(() => { parsePathname() })
  window.addEventListener('popstate', parsePathname)
  onDestroy(() => { window.removeEventListener('popstate', parsePathname) })

  function backToList() { displayStatus = 'list' }
  function load(event) { displayStatus = event.detail.rant }
  function parsePathname() {
    const pathComponents = location.pathname.split('/')
    if (pathComponents[2] != null) {
      displayStatus = pathComponents[2]
    } else {
      displayStatus = 'list'
    }
  }
</script>

<main>
  {#if displayStatus === 'fullStack'} <FullStack on:back={backToList}/>
  {:else if displayStatus === 'jwtLambda'} <JWTLambda on:back={backToList}/>
  {:else} <RantsList on:load={load}/>
  {/if}
</main>

<style>
  main {
    width: 100%;
    height: 100%;
  }
</style>